export default {
  data() {
    return {
      deploymentFormLoad: false,
      deploymentRank: null,
      deploymentRecoveryPhone: '',
      deploymentSelectedCity: null,
      deploymentAddress: '',
      deploymentNote: '',
      deploymentTag: [],
      deploymentVehicleType: null,
      deploymentVehicleCounte: null,
      listOfDeploymentSelectedCodes: [],
      searchGeoLocationTextForDeployment: '',
      acceptLocationDeployment: false,
      deploymentInformTypeId: null,
      passedTime: 0,
      passedTimeInterval: null,
      showPassedTime: null,
      latLngForShow: '',
    };
  },
  methods: {
    toggleTimer: function () {
      this.passedTimeInterval = setInterval(this.incrementTime, 1000);
    },
    incrementTime: function () {
      this.passedTime = parseInt(this.passedTime) + 1;
      this.showPassedTime = new Date(this.passedTime * 1000).toISOString().substring(14, 19);
    },
    addCodeForDeploymentMission: function () {
      if (!this.deploymentVehicleType) {
        this.snackText = 'لطفا نوع کد را انتخاب نمایید';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      if (
        this.deploymentVehicleCounte === null ||
        this.deploymentVehicleCounte === undefined ||
        this.deploymentVehicleCounte === ''
      ) {
        this.snackText = ' لطفا تعداد ' + this.deploymentVehicleType.title + ' را وارد نمایید';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      if (this.listOfDeploymentSelectedCodes.length > 0) {
        for (let i = 0; i < this.listOfDeploymentSelectedCodes.length; i++) {
          if (this.listOfDeploymentSelectedCodes[i].id == this.deploymentVehicleType.id) {
            this.snackText = ' کد ' + this.deploymentVehicleType.title + ' قبلا انتخاب شده است';
            this.$refs.snackRef.snackModel = true;
            this.snackColor = '#FF5252';
            this.snakIcon = 'mdi-information';
            return;
          }
        }
      }
      this.listOfDeploymentSelectedCodes.push({
        title: this.deploymentVehicleType.title,
        count: this.deploymentVehicleCounte,
        id: this.deploymentVehicleType.id,
      });
      this.deploymentVehicleType = null;
      this.deploymentVehicleCounte = null;
    },
    // methods: {
    //     toggleTimer: function () {
    //         this.passedTimeInterval = setInterval(this.incrementTime, 1000);
    //     },
    //     incrementTime: function () {
    //         this.passedTime = parseInt(this.passedTime) + 1;
    //         this.showPassedTime = new Date(this.passedTime * 1000).toISOString().substring(14, 19)
    //     },
    //     addCodeForDeploymentMission: function () {
    //         if (!this.deploymentVehicleType) {
    //             this.snackText = "لطفا نوع کد را انتخاب نمایید"
    //             this.$refs.snackRef.snackModel = true;
    //             this.snackColor = "#FF5252";
    //             this.snakIcon = "mdi-information";
    //             return;
    //         }
    //         if (this.deploymentVehicleCounte === null || this.deploymentVehicleCounte === undefined || this.deploymentVehicleCounte === "") {
    //             this.snackText = " لطفا تعداد " + this.deploymentVehicleType.title + " را وارد نمایید"
    //             this.$refs.snackRef.snackModel = true;
    //             this.snackColor = "#FF5252";
    //             this.snakIcon = "mdi-information";
    //             return;
    //         }
    //         if (this.listOfDeploymentSelectedCodes.length > 0) {
    //             for (let i = 0; i < this.listOfDeploymentSelectedCodes.length; i++) {
    //                 if (this.listOfDeploymentSelectedCodes[i].id == this.deploymentVehicleType.id) {
    //                     this.snackText = " کد " + this.deploymentVehicleType.title + " قبلا انتخاب شده است"
    //                     this.$refs.snackRef.snackModel = true;
    //                     this.snackColor = "#FF5252";
    //                     this.snakIcon = "mdi-information";
    //                     return;
    //                 }
    //             }
    //         }
    //         this.listOfDeploymentSelectedCodes.push({ title: this.deploymentVehicleType.title, count: this.deploymentVehicleCounte, id: this.deploymentVehicleType.id });
    //         this.deploymentVehicleType = null;
    //         this.deploymentVehicleCounte = null;
    //     },
    //     removeCodeFromDeploymentMission: function (id) {
    //         for (let i = 0; i < this.listOfDeploymentSelectedCodes.length; i++) {
    //             if (this.listOfDeploymentSelectedCodes[i].id == id) {
    //                 this.listOfDeploymentSelectedCodes.splice(i, 1);
    //             }
    //         }
    //     },
    //     //map
    //     searchForGeoLocation: function () {
    //         if (this.searchGeoLocationTextForDeployment) {
    //             this.getMapGeoCode(this.searchGeoLocationTextForDeployment);
    //         }
    //     },
    //     goToAddress: function (data) {
    //         this.$refs.modalmap.mapObject.flyTo([data.longitude, data.latitude], 16);
    //     },
    //     setAddress: function (text) {
    //         this.deploymentAddress = text;
    //     },
    //     cityChange: function () {
    //         this.searchForLocation(this.deploymentSelectedCity.title, this.deploymentSelectedCity.province.title);
    //     },
    //     goToCityFromCity: function (data) {
    //         this.$refs.modalmap.mapObject.flyTo([data[0].lat, data[0].lon], 12);
    //     },
    //     cleanForm: function () {
    //         this.deploymentFormLoad = false;
    //         this.deploymentRank = null;
    //         this.deploymentRecoveryPhone = "";
    //         this.deploymentSelectedCity = null;
    //         this.deploymentAddress = "";
    //         this.deploymentNote = "";
    //         this.deploymentTag = [];
    //         this.deploymentVehicleType = null;
    //         this.deploymentVehicleCounte = null;
    //         this.listOfDeploymentSelectedCodes = [];
    //         this.searchGeoLocationTextForDeployment = "";
    //         this.passedTime = 0;
    //         clearInterval(this.passedTimeInterval);
    //         this.passedTimeInterval = null;
    //         this.showPassedTime = null;
    //         this.latLngForShow = "";
    //         this.acceptLocationDeployment = false;
    //         this.deploymentInformTypeId = null
    //     },
    //     cancleDeployment: function () {
    //         this.cleanForm();
    //         this.$root.$refs.Home.deploymentModal = false;
    //     }
    //   }
    //map
    searchForGeoLocation: function () {
      if (this.searchGeoLocationTextForDeployment) {
        this.getMapGeoCode(this.searchGeoLocationTextForDeployment);
      }
    },
    goToAddress: function (data) {
      this.$refs.modalmap.mapObject.flyTo([data.longitude, data.latitude], 15);
    },
    setAddress: function (text) {
      this.deploymentAddress = text;
    },
    cityChange: function () {
      this.searchForLocation(
        this.deploymentSelectedCity.title,
        this.deploymentSelectedCity.province.title,
      );
    },
    goToCityFromCity: function (data) {
      this.$refs.modalmap.mapObject.flyTo([data[0].lat, data[0].lon], 12);
    },
    cleanForm: function () {
      this.deploymentFormLoad = false;
      this.deploymentRank = null;
      this.deploymentRecoveryPhone = '';
      this.deploymentSelectedCity = null;
      this.deploymentAddress = '';
      this.deploymentNote = '';
      this.deploymentTag = [];
      this.deploymentVehicleType = null;
      this.deploymentVehicleCounte = null;
      this.listOfDeploymentSelectedCodes = [];
      this.searchGeoLocationTextForDeployment = '';
      this.passedTime = 0;
      clearInterval(this.passedTimeInterval);
      this.passedTimeInterval = null;
      this.showPassedTime = null;
      this.latLngForShow = '';
      this.acceptLocationDeployment = false;
      this.deploymentInformTypeId = null;
    },
    cancleDeployment: function () {
      this.cleanForm();
      this.$root.$refs.Home.deploymentModal = false;
    },
  },
};
